"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandColourSetup = void 0;
var styles = __importStar(require("./BrandColourSetup.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BrandColors_1 = __importStar(require("DreamCoat/BrandSetUp/BrandColor/BrandColors"));
var BrandColorTooltipContent = function () {
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", justify: "center" },
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, className: styles.tooltipHeading }, "Brand Colors"),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", className: styles.tooltipText }, "You can customize this later and add up to 7 colors.")));
};
var BrandColourSetup = function (_a) {
    var dataStore = _a.dataStore;
    return (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xxs", className: styles.label },
            react_1.default.createElement(kaleidoscope_1.Label, { long: true, size: "s" }, "Add brand colors"),
            react_1.default.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, content: react_1.default.createElement(BrandColorTooltipContent, null), size: kaleidoscope_1.TooltipSize.Large },
                react_1.default.createElement(icons_1.Help, { size: icons_1.IconSize.Small, color: "default" }))),
        react_1.default.createElement(BrandColors_1.default, { brandStore: dataStore, maxColors: 4, colorSize: BrandColors_1.BrandColorSize.XSmall })));
};
exports.BrandColourSetup = BrandColourSetup;
